// This is meant to be deleted/deprecated after mojo deploy

/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/naming-convention */
export enum AttentiveSignUpSourceId {
  'desktop' = 200305,
  'mobile' = 200302
}
